class GeoIPModal extends HTMLElement {
  constructor() {
    super();
    this.select = null;
    this.continueBtn = null;
    this.stayBtn = null;
    this.modal = null;
    this.modalOverlay = null;
    this.storeData = [];
    this.currentUrl = window.location.origin;
    this.selectedUrl = null;
  }

  async connectedCallback() {
    this.select = this.querySelector('.country-select');
    this.continueBtn = this.querySelector('.btn-redirect');
    this.stayBtn = this.querySelector('.redirect-close');
    this.modal = this.querySelector('.redirect-popup');
    this.modalOverlay = this.querySelector('.redirect-overlay');
    this.storeData = this.getStoreData();

    const cookiePreference = this.getCookie('countryPreference');

    if (cookiePreference) {
      const preferredStore = this.matchStoreByCountry(cookiePreference);
      if (preferredStore && this.normalizeUrl(preferredStore.url) !== this.normalizeUrl(this.currentUrl)) {
        this.populateUI(preferredStore);
        this.showModal();
        this.attachEvents();
      }
      return;
    }

    const userCountryCode = await this.fetchUserCountryCode();

    if (userCountryCode) {
      const geoMatchedStore = this.matchStoreByCountry(userCountryCode);
      if (geoMatchedStore && this.normalizeUrl(geoMatchedStore.url) !== this.normalizeUrl(this.currentUrl)) {
        this.populateUI(geoMatchedStore);
        this.showModal();
        this.attachEvents();
      }
    }
  }

  attachEvents() {
    this.select.addEventListener('change', () => this.onSelectChange());

    this.continueBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.setPreferenceAndRedirect();
    });

    this.stayBtn.addEventListener('click', () => {
      const currentCode = this.getCountryCodeFromCurrentStore();
      this.setPreferenceAndClose(currentCode);
    });
  }

  getStoreData() {
    const raw = document.getElementById('store-config');
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw.textContent);
      return parsed.stores.map((store) => ({
        name: store.name,
        url: store.url,
        countryCodes: store.countryCodes.map((code) => code.trim().toUpperCase()),
      }));
    } catch (e) {
      return [];
    }
  }

  setCookie(cname, cvalue, exdays = 30) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    const domain = location.hostname.split('.').slice(-2).join('.');
    document.cookie = `${cname}=${cvalue};${expires};path=/;domain=.${domain};SameSite=Lax;Secure`;
  }

  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length);
      }
    }
    return '';
  }

  matchStoreByCountry(countryCode) {
    if (!countryCode) return null;
    return this.storeData.find((store) => store.countryCodes.includes(countryCode.toUpperCase()));
  }

  getCountryCodeFromCurrentStore() {
    const store = this.storeData.find((s) => this.normalizeUrl(s.url) === this.normalizeUrl(this.currentUrl));
    return store?.countryCodes[0] || null;
  }

  async fetchUserCountryCode() {
    try {
      if (this.getCookie('countryLocation')) {
        return this.getCookie('countryLocation');
      }

      const response = await fetch(
        'https://api.ipstack.com/check?access_key=7457acb4df00ff5c584fa86c29721c01&fields=country_code',
      );
      const data = await response.json();

      const countryCode = data.country_code;

      if (countryCode) {
        this.setCookie('countryLocation', countryCode, 30);
      }

      return countryCode;
    } catch (e) {
      return null;
    }
  }

  buildFullUrl(baseUrl) {
    const currentPath = window.location.pathname + window.location.search;
    return baseUrl.replace(/\/+$/, '') + currentPath;
  }

  normalizeUrl(url) {
    try {
      const parsed = new URL(url);
      return parsed.origin.toLowerCase();
    } catch (e) {
      return url.replace(/\/+$/, '').toLowerCase();
    }
  }

  populateUI(matchedStore) {
    let matchedOption = null;

    for (const option of this.select.options) {
      const optionUrl = option.dataset.url;
      if (!optionUrl) continue;

      if (this.normalizeUrl(optionUrl) === this.normalizeUrl(matchedStore.url)) {
        matchedOption = option;
        option.selected = true;
        this.selectedUrl = this.buildFullUrl(optionUrl);
        break;
      } else {
        option.selected = false;
      }
    }

    if (!this.selectedUrl && this.select.options.length > 0) {
      const firstOption = this.select.options[0];
      this.selectedUrl = this.buildFullUrl(firstOption.dataset.url || '');
      this.select.selectedIndex = 0;
    }

    if (this.selectedUrl) {
      this.continueBtn.setAttribute('href', this.selectedUrl);
    }
  }

  onSelectChange() {
    const selected = this.select.options[this.select.selectedIndex];
    const baseUrl = selected.dataset.url;

    if (baseUrl) {
      this.selectedUrl = this.buildFullUrl(baseUrl);
      this.continueBtn.setAttribute('href', this.selectedUrl);
    }
  }

  setPreferenceAndRedirect() {
    const selected = this.select.options[this.select.selectedIndex];
    const preferredCode = selected.value;

    if (preferredCode) {
      this.setCookie('countryPreference', preferredCode, 30);
    }

    if (this.selectedUrl) {
      window.location.href = this.selectedUrl;
    }
  }

  setPreferenceAndClose(currentCode) {
    if (currentCode) {
      this.setCookie('countryPreference', currentCode, 30);
    }
    this.hideModal();
  }

  showModal() {
    this.modal.classList.add('active');
    this.modalOverlay.classList.add('active');
  }

  hideModal() {
    this.modal.classList.remove('active');
    this.modalOverlay.classList.remove('active');
  }
}

customElements.define('geo-ip-modal', GeoIPModal);
